// 银行管理（与业务管理同级的一级菜单）
export default {
  title: '银行管理',
  type: 'folder',
  name: Symbol('bank-management'),
  route: '/bank/config',
  inNav: true,
  icon: 'iconfont icon-rongzi',
  isElementIcon: false,
  order: 6,
  permission: ['访问银行管理'],
  children: [
    {
      title: '银行对接配置',
      type: 'view',
      name: Symbol('bank-config'),
      route: '/bank/config',
      filePath: 'view/business/bank/bank-config.vue',
      inNav: true,
      icon: 'iconfont icon-shezhi',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '银行列表',
      type: 'view',
      name: Symbol('bank-list'),
      route: '/bank/list',
      filePath: 'view/business/bank/list.vue',
      inNav: true,
      icon: 'iconfont icon-rongzi',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '融资申请推送管理',
      type: 'view',
      name: Symbol('bank-push-manage'),
      route: '/bank/push-manage',
      filePath: 'view/business/bank/push-manage.vue',
      inNav: true,
      icon: 'iconfont icon-tuisong',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '银行审批结果查询',
      type: 'view',
      name: Symbol('bank-approval-query'),
      route: '/bank/approval-query',
      filePath: 'view/business/bank/approval-query.vue',
      inNav: true,
      icon: 'iconfont icon-chaxun',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '放款记录',
      type: 'view',
      name: Symbol('bank-disburse-record'),
      route: '/bank/disburse-record',
      filePath: 'view/business/bank/disburse-record.vue',
      inNav: true,
      icon: 'iconfont icon-liushui',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '模拟银行审批',
      type: 'view',
      name: Symbol('bank-mock-approval'),
      route: '/bank/mock-approval',
      filePath: 'view/business/bank/mock-approval.vue',
      inNav: true,
      icon: 'iconfont icon-moni',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '还款管理',
      type: 'view',
      name: Symbol('bank-repayment-manage'),
      route: '/bank/repayment-manage',
      filePath: 'view/business/bank/repayment-manage.vue',
      inNav: true,
      icon: 'iconfont icon-huankuan',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
    {
      title: '电子合同签署',
      type: 'view',
      name: Symbol('bank-contract-sign'),
      route: '/bank/contract-sign',
      filePath: 'view/business/bank/contract-sign.vue',
      inNav: true,
      icon: 'iconfont icon-hetong',
      isElementIcon: false,
      permission: ['访问银行管理'],
    },
  ],
}
